import React from 'react';

import { LoggerSettings } from '../interfaces';

export const LoggerContext: React.Context<LoggerSettings> = React.createContext<LoggerSettings>({
  applicationId: '', clientToken: '', service: '', env: '', version: ''
});
